var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PaymentComponent',{attrs:{"user":_vm.user,"show_footer":true},on:{"refreshUser":_vm.refreshUser}})
}
var staticRenderFns = []

export { render, staticRenderFns }